// 图片处理混入
export const imageProcessMixin = {
  methods: {
    processImageUrl(url) {
      const defaultParams = {
        tos: "image/resize,h_600/format,png",
        oss: "image/resize,h_600/format,png",
        bce: "image/resize,h_600/format,f_png",
      };

      if (!url || typeof url !== "string") {
        return url;
      }

      const targetStartParams = [
        "x-tos-process",
        "x-oss-process",
        "x-bce-process",
      ];
      let baseUrl = url;
      const queryIndex = url.indexOf("?");
      if (queryIndex !== -1) {
        const queryString = url.substring(queryIndex + 1);
        const shouldReplace = targetStartParams.some((param) =>
          queryString.startsWith(param)
        );
        if (shouldReplace) {
          baseUrl = url.substring(0, queryIndex);
        }
      }
      const separator = baseUrl.includes("?") ? "&" : "?";
      const newParams = [
        `x-tos-process=${defaultParams.tos}`,
        `x-oss-process=${defaultParams.oss}`,
        `x-bce-process=${defaultParams.bce}`,
      ];
      const processedUrl = `${baseUrl}${separator}${newParams.join("&")}`;

      return processedUrl;
    },
  },
};
